$(() => {
  const joinBtn = document.getElementById("join-btn");
  const offerContainer = document.querySelector(".offer");
  const offerTopBar = document.getElementById("offer-top-bar");
  setTopBarVisibility();
  document.addEventListener("scroll", () => setTopBarVisibility());
  function setTopBarVisibility() {
    const propertyName = "--offer-top-bar-hidden";
    const visible = joinBtn.getBoundingClientRect().bottom < 0;
    if (visible) {
      offerTopBar.setAttribute("aria-hidden", "false");
      offerTopBar.style.setProperty(propertyName, "0");
      offerContainer.classList.add("top-bar-visible");
    } else {
      offerTopBar.setAttribute("aria-hidden", "true");
      offerTopBar.style.setProperty(propertyName, "1");
      offerContainer.classList.remove("top-bar-visible");
    }
  }
});
